const { REACT_APP_COGNITO_DEFAULT_GROUP } = process.env;

export const Role = {
  ADMIN:'admin',
  AZURE: REACT_APP_COGNITO_DEFAULT_GROUP,
  COGNITO:'cognitoadmin',
  DEMO: 'demo',
}
